import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import * as S from './FlowDebugger.styles';
import { DebugTree } from './DebugTree/DebugTree';
import { useSelector } from 'react-redux';
import { getFlowDebugStateFavoriteFieldsList } from 'extractFromState';
import { useCallback } from 'react';

const FlowDebugger = ({ isInspectorOpen, isCustomerMessage, messageClasses, flowDebugState }) => {
  const inspectorFavorites = useSelector(getFlowDebugStateFavoriteFieldsList);

  const buildStateFavoriteFieldsComponent = useCallback(() => {
    let stateFavoriteFields = {};
    const errorsField = get(flowDebugState, 'errors', null);
    const defaultFavoriteFields = {
      ...(!isEmpty(errorsField) && { errors: errorsField }),
    };

    stateFavoriteFields =
      inspectorFavorites?.reduce(
        (acc, favoriteState) => ({
          ...acc,
          [favoriteState.alias || favoriteState.path]: get(flowDebugState, favoriteState.path, null),
        }),
        defaultFavoriteFields
      ) || defaultFavoriteFields;

    return (
      !isEmpty(stateFavoriteFields) && (
        <S.DebugMessageContainer className={`debug-favorites-${messageClasses.join(' ')}`}>
          <S.DebugMessageCodeBox>
            <DebugTree pathBase="" data={stateFavoriteFields} />
          </S.DebugMessageCodeBox>
        </S.DebugMessageContainer>
      )
    );
  }, [flowDebugState, inspectorFavorites, messageClasses]);

  return (
    <>
      {!isCustomerMessage && buildStateFavoriteFieldsComponent()}
      {isInspectorOpen && (
        <S.DebugMessageContainer className={`debug-${messageClasses.join(' ')}`}>
          <S.DebugMessageCodeBox>
            <DebugTree pathBase="" data={flowDebugState} />
          </S.DebugMessageCodeBox>
        </S.DebugMessageContainer>
      )}
    </>
  );
};

export default FlowDebugger;
